"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = void 0;
var _mui = require("@ori-ui/mui");
var _imageSizesHelper = require("@ori/image-sizes-helper");
var _common = require("../../common");
var _LazyImage = require("../LazyImage");
var _ImagePlaceholder = require("./ImagePlaceholder");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const getTransitionBoxSrcSet = (theme, imageUrl) => {
  const imagesVariants = {
    url: imageUrl,
    backgroundColor: theme.palette.grey[100],
    imageFormat: 'WebP',
    imageSizeMultiplier: 2,
    params: [{
      width: _styles.PRODUCT_IMAGE_SIZE,
      quality: 90
    }]
  };
  return (0, _imageSizesHelper.generateSrcSet)((0, _imageSizesHelper.getImageVariants)(imagesVariants));
};
const getOfferBundleBoxSrcSet = (theme, imageUrl) => {
  const imagesVariants = {
    url: imageUrl,
    backgroundColor: theme.palette.grey[100],
    imageSizeMultiplier: 2,
    params: [{
      width: _styles.BUNDLE_IMAGE_SIZE,
      quality: 90
    }]
  };
  return (0, _imageSizesHelper.generateSrcSet)((0, _imageSizesHelper.getImageVariants)(imagesVariants));
};
const Image = ({
  productImageUrls
}) => {
  const theme = (0, _mui.useTheme)();
  if (productImageUrls && productImageUrls.length > 1) {
    const images = productImageUrls.slice(0, 3);
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ImageRoot, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BundleImages, {
        "data-testid": _common.PRODUCT_TILE_BUNDLES_IMAGES,
        imagesCount: images.length,
        children: images.map(imageUrl => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BundleImage, {
          alt: imageUrl,
          sizes: `${_styles.BUNDLE_IMAGE_SIZE}px`,
          srcSet: getOfferBundleBoxSrcSet(theme, imageUrl)
        }, imageUrl))
      })
    });
  }
  const imageUrl = productImageUrls?.[0];
  if (imageUrl) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ImageRoot, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LazyImage.LazyImage, {
        alt: productImageUrls[0],
        customImagePlaceholder: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImagePlaceholder.ImagePlaceholder, {}),
        height: _styles.PRODUCT_IMAGE_SIZE,
        sizes: `${_styles.PRODUCT_IMAGE_SIZE}px`,
        srcSet: getTransitionBoxSrcSet(theme, imageUrl),
        width: _styles.PRODUCT_IMAGE_SIZE
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ImageRoot, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImagePlaceholder.ImagePlaceholder, {})
  });
};
exports.Image = Image;
//# sourceMappingURL=Image.js.map